export const Data = {
    "外链地址":"外鏈地址",
    "资料标题":"資料標題",
    "引用自":"引用自: ",
    "允许视频倍速":"允許視頻倍速",
    "不允许视频倍速播放":"不允許視頻倍速播放",
    "允许进度条拖拽":"允許進度條拖拽",
    "不允许进度条拖拽":"不允許進度條拖拽",
    "允许跳过互动答题":"允許跳過互動答題",
    "添加外链素材":"添加外鏈素材",
    "预览":"預覽",
    "逻辑错误":"邏輯錯誤",
    "上传中当前进度":"上傳中，當前進度:",
    "外链资源":"外鏈資源",
    "截至时间":"截至時間：",
    "时长":"時長",
    "需回复":"需回復",
    "人已读":"人已讀",
    "人已参与":"人已參與",
    "直播参与人数":"直播參與人數",
    "平均在线时长":"平均在線時長",
    "完成回顾学习人数":"完成回顧學習人數",
    "最后访问时间":"最後訪問時間:",
    "查阅":"查閱",
    "学习总时长":"學習總時長",
    "学习进度":"學習進度",
    "互动答题完成度":"互動答題完成度",
    "直播在线":"直播在線",
    "点我发弹幕":"點我發彈幕...",
    "发送弹幕/评论":"發送彈幕/評論",
    "很抱歉该视频被老师设置成不对外开放暂时无法预览":"很抱歉，該視頻被老師設置成不對外開放，暫時無法預覽",
    "当前老师设置为不允许跳过互动答题":"當前老師設置為不允許跳過互動答題",
    "前往答题":"前往答題",
    "当前老师设置为允许跳过互动答题":"當前老師設置為允許跳過互動答題",
    "跳过答题":"跳過答題",
    "作答保存成功":"作答保存成功",
    "主画面":"主畫面",
    "批阅互动":"批閱互動",
    "个视频资源":"個視頻資源",
    "资源类型":"資源類型",
}